import { render } from "./carconfig.vue?vue&type=template&id=f989d726"
import script from "./carconfig.vue?vue&type=script&lang=js"
export * from "./carconfig.vue?vue&type=script&lang=js"

import "./carconfig.vue?vue&type=style&index=0&id=f989d726&lang=scss"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__